import { render } from "./explore-residents.vue?vue&type=template&id=e5606b28"
import script from "./explore-residents.vue?vue&type=script&lang=js"
export * from "./explore-residents.vue?vue&type=script&lang=js"

import "./explore-residents.vue?vue&type=style&index=0&id=e5606b28&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__